import React from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { Trans } from 'react-i18next'
import classNames from 'classnames'

const WebHomeTable = ({
  limit,
  currentPage,
  pageCount,
  portals,
  values,
  onPortalDelete,
  isAdmin = false,
  language,
}) => {
  return (
    <div>
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>
              <Trans>default.seq.label</Trans>
            </th>
            <th>
              <Trans>info.title.label</Trans>
            </th>
            <th className="is-hidden-mobile">
              <Trans>info.tags.label</Trans>
            </th>
            <th className="is-hidden-mobile">
              <Trans>info.location.streetAddress.label</Trans>
            </th>
            <th>
              <Trans>town.label</Trans>
            </th>
            <th>
              <Trans>modifiedDate.label</Trans>
            </th>
          </tr>
        </thead>
        <tbody>
          {_.map(portals, (portal, index) => {
            index = (currentPage - 1) * limit + index + 1

            return (
              <PortalRow
                index={index}
                key={portal._id}
                portal={portal}
                language={language}
                tags={portal.tags}
                onPortalDelete={onPortalDelete}
                isAdmin={isAdmin}
              />
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const PortalRow = ({
  index,
  portal,
  tags,
  onPortalDelete,
  language = 'th',
  isAdmin,
}) => (
  <tr
    className={classNames({
      'has-background-warning': portal.status === 'DRAFT',
    })}
  >
    <td>{index}</td>
    <td>
      <Link to={`/${portal._id}/info`}>
        {_.get(portal, `title.${language}`) ||
          `title not available in [${_.upperCase(language)}].`}
      </Link>
    </td>
    <td className="is-hidden-mobile">{!_.isEmpty(tags) && tags.join(', ')}</td>
    <td className="is-hidden-mobile">{_.get(portal, `location.streetAddress.${language}`)}</td>
    <td>
      {_.map(portal.townRefs, (townRef, index) => (
        <Link key={townRef} to={`/towns/${townRef}/listings`}>
          {townRef} {index !== _.size(portal.townRefs) - 1 && ', '}
        </Link>
      ))}
    </td>
    <td>
      {_.isEmpty(portal.modifiedDate)
        ? '-'
        : moment(portal.modifiedDate).format('DD-MM-YY HH:mm')}
    </td>
    {isAdmin && (
      <td>
        <div
          className="button is-danger"
          onClick={() => onPortalDelete(portal)}
        >
          Delete
        </div>
      </td>
    )}
  </tr>
)

export default WebHomeTable



// WEBPACK FOOTER //
// ./src/components/templates/portal-list/PortalListTable.js